import { constructionCaseGateway } from '@/di-container/construction-case/gateway/client';
import { ApiPagingResponseData } from '@remodeling/base';
import {
  ConstructionCaseContent,
  GetConstructionCaseListRequest,
  GetConstructionCaseListResponse,
} from '@remodeling/content';
import querystring from 'query-string';
import { useEffect, useMemo, useRef, useState } from 'react';
import { KeyLoader } from 'swr';
import useSWRInfinite from 'swr/infinite';

interface UseConstructionProps {
  shopId: number;
  tabState: string;
}

const useConstruction = ({ shopId, tabState }: UseConstructionProps) => {
  const [page, setPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const ref = useRef<HTMLDivElement>(null);
  const getKey: KeyLoader = () => {
    const query = querystring.stringify({
      page,
      size: 30,
      shopId: String(shopId),
      exhibitHall: tabState,
      sort: 'R',
      typeValue: 'P',
    });
    return `construction_${query}`;
  };

  const { data: constructData } =
    useSWRInfinite<GetConstructionCaseListResponse>(getKey, async (query) => {
      setIsLoading(true);
      const data = await constructionCaseGateway().getList.exec(
        querystring.parse(query) as unknown as GetConstructionCaseListRequest,
      );
      setIsLoading(false); // API 요청이 완료되었을 때 isLoading을 false로 설정
      return data;
    });

  const constructList:
    | ApiPagingResponseData<ConstructionCaseContent>
    | undefined = useMemo(() => {
    if (constructData?.[0].data) {
      const { data } = constructData[0];
      setIsLoading(false);
      return data;
    } else {
      return undefined;
    }
  }, [constructData]);

  useEffect(() => {
    if (ref) {
      ref.current?.scrollTo(0, 0);
    }
  }, [page]);

  return {
    isLoading,
    setPage,
    page,
    ref,
    constructList,
  };
};

export default useConstruction;
